import React, { useRef } from "react";
import "./Home.css";
import GameTypesGrid from "./GameTypesGrid";
import BlowingPetals from "./BlowingPetals";
import PaperSun from "./PaperSun";
import CareTeamNotice from "./CareTeam/player/CareTeamNotice";
import { ReactComponent as Bird1 } from "../images/Bird-SVG-Flying-1.svg";
import { ReactComponent as Bird2 } from "../images/Bird-SVG-Flying-2.svg";
import { ReactComponent as Bird3 } from "../images/Bird-SVG-Flying-3.svg";
import { ReactComponent as Bird4 } from "../images/Bird-SVG-Flying-4.svg";

const Home = ({ onLogin }) => {
  // The hero band owns the shared wind field's coordinate space. The petals' canvas
  // fills it, so handing this ref to PaperSun lets the sun sample the same wind at
  // its true position in the scene — keeping its rays in sync with the petals.
  const heroRef = useRef(null);

  return (
    <div className="trailhead">
      {/* "You're now sharing with…" or a provider's request waiting for them */}
      <CareTeamNotice />
      {/* The nature scene is the hero: a torn cut-paper horizon across the top,
          dressed as a full diorama, with the brand folded in over the meadow. */}
      <section className="trail-hero" ref={heroRef}>
        {/* Layered hills, anchored to the bottom of the band */}
        <div className="paper-band paper-band--hills-far" />
        <div className="paper-band paper-band--hills" />
        <div className="paper-band paper-band--meadow" />

        {/* The diorama layer — bespoke cut-paper art (placeholders for now) staged
            on the horizon. Pieces are anchored to the bottom so they "stand" on the
            land; a scatter of shrubs clusters along the trail. */}
        <div className="trail-hero__scene" aria-hidden="true">
          <div className="decor decor--sun">
            {/* Real cut-paper sun: rays sway on the same wind that blows the leaves.
                Size is owned by .decor--sun (CSS) so it can scale per breakpoint.
                windAnchorRef ties the sun's wind sampling to the hero's coordinate
                space (shared with the petals) so the same gusts move both. */}
            <PaperSun fill tone="var(--color-secondary)" windStrength={0.6} windAnchorRef={heroRef} />
          </div>
          {/* A loose skein of birds drifting up toward the sun — four wing poses
              scattered at varied sizes for depth. Recoloured to a soft warm ink
              by .hero-bird (CSS) so they read as distant silhouettes. */}
          <div className="decor decor--bird-1">
            <Bird1 className="hero-bird" />
          </div>
          <div className="decor decor--bird-2">
            <Bird2 className="hero-bird" />
          </div>
          <div className="decor decor--bird-3">
            <Bird3 className="hero-bird" />
          </div>
          <div className="decor decor--bird-4">
            <Bird4 className="hero-bird" />
          </div>
          <div className="decor decor--shrub-left">
            <div className="hero-shrub hero-shrub--v2" />
          </div>
          <div className="decor decor--tree">
            <div className="hero-tree" />
          </div>
          <div className="decor decor--signpost">
            <div className="hero-sign" />
          </div>
          <div className="decor decor--fox">
            <div className="hero-shrub hero-shrub--v3" />
          </div>
          <div className="decor decor--ferns">
            <div className="hero-tree" />
          </div>
          <div className="decor decor--shrub-right">
            <div className="hero-shrub hero-shrub--v5" />
          </div>
          <div className="decor decor--flowers">
            <div className="hero-shrub hero-shrub--v1" />
          </div>
          <div className="decor decor--mushrooms">
            <div className="hero-shrub hero-shrub--v4" />
          </div>
        </div>

        {/* Cut-paper leaves drift across the scene, in front of the hills but
            behind the brand */}
        <BlowingPetals density={9} windStrength={0.6} className="trail-hero__petals" />

        {/* Brand, cut from paper and pinned in front of the scene */}
        <div className="trail-hero__inner">
          <h1 className="trail-hero__wordmark heading-primary">Mend Grove</h1>
        </div>
      </section>

      {/* The catalogue rises up over the meadow: a paper banner over a scatter of
          game tiles. The wildflower meadow base is now drawn by FlowerTurf inside
          GameTypesGrid (scattered flowers that keep clear of the path), so the trail,
          clearings, and tiles all sit on top of it. */}
      {/* The hero's meadow band continues over the seam as a torn overhang
          (same green, ragged bottom edge), so the two sections read as
          overlapping cut-paper layers instead of butting on a straight line.
          The overhang itself (.trail-catalogue__ridge) is rendered INSIDE
          GameTypesGrid's layer stack so the cobble path can slip beneath it
          while the flowers ride over it — see the clip note in Home.css. */}
      <main className="trail-catalogue">
        <GameTypesGrid />
      </main>
    </div>
  );
};

export default Home;
